var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightXxsmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40532 5.00456C7.40062 4.84015 7.33955 4.68983 7.20802 4.56769L3.55338 0.997605C3.45004 0.89426 3.31851 0.837891 3.16349 0.837891C2.85346 0.837891 2.60449 1.08216 2.60449 1.39219C2.60449 1.54251 2.66556 1.68813 2.7736 1.79618L6.06654 4.99986L2.7736 8.21294C2.67026 8.32098 2.60449 8.4619 2.60449 8.61692C2.60449 8.92695 2.85346 9.17122 3.16349 9.17122C3.31851 9.17122 3.45004 9.11485 3.55338 9.01151L7.20802 5.43673C7.33955 5.30989 7.40532 5.16897 7.40532 5.00456Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightXxsmall);
export default __webpack_public_path__ + "static/media/chevron-right-xxsmall.cc52dba6.svg";
export { ForwardRef as ReactComponent };